// src/api/index.js
// Same-origin proxy: SWA Function in production, CRA proxy (src/setupProxy.js) in
// local development.
import axios from 'axios';
import { createAppTransport } from '@1823-partners/core';

const api = createAppTransport({ axios, appName: 'scenarios' });

export const fetchConfigs = async () => {
  return api.get('/scenario_configs');
};

export const fetchLatestAsofdt = (env = 'UAT') =>
  api.get('/latest_asofdt', { params: { env } });

export const fetchScenarios = async (env = 'DEV', asofdt) => {
  return api.get('/scenarios', { params: { env, asofdt } });
};

export const fetchScenarioGroups = async (env = 'DEV', asofdt) => {
  return api.get('/scenario_groups', { params: { env, asofdt } });
};

export const fetchBooks = async (env = 'DEV', asofdt) => {
  return api.get('/books', { params: { env, asofdt } });
};

export const fetchCusips = async (env = 'DEV', asofdt) => {
  return api.get('/cusips', { params: { env, asofdt } });
};

export const fetchPositions = async (env = 'DEV', asofdt) => {
  return api.get('/positions', { params: { env, asofdt } });
};

export const createConfig = async (config) => {
  return api.post('/save_configs', config);
};

export const runScenario = async (data) => {
  const payload = typeof data === 'string' ? { configId: data } : data;
  return api.post('/run_scenario', payload);
};

export const fetchScenarioRuns = async (configId) => {
  return api.get(`/scenario_runs?configId=${configId}`);
};

export const fetchCashflow = async (payload) => {
  return api.post('/cashflow', payload);
};

export const fetchMetrics = async (payload) => {
  return api.post('/metrics', payload);
};

export const uploadScenarios = async (file, env = 'DEV') => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('env', env);

  return api.post('/upload_scenarios', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

// Metrics Mode API - returns combined cashflows and analytics
export const fetchMetricsMode = async (payload) => {
  // payload: { cusips, asofdt, scenarios, env }
  return api.post('/portfolio_analytics', payload);
};

// With batchJobId, every row of that one run (a server without it returns the
// default window: active rows plus the latest 50 outcomes).
export const fetchScenarioTelemetry = (configId, signal, batchJobId) =>
  api.get('/scenario_telemetry', {
    params: batchJobId ? { configId, batchJobId } : { configId },
    signal,
  });

export const fetchScenarioTelemetryEvents = (configId, runId, offset, signal) =>
  api.get('/scenario_telemetry_events', { params: { configId, runId, offset }, signal });

export default api;
